import React from "react";
import { confirmAlert } from "react-confirm-alert";
import Button from "../Button/Button";
import styles from "./CustomConfirmAlert.module.css";
import "react-confirm-alert/src/react-confirm-alert.css";

export default function CustomConfirmAlert({
  title,
  subtitle,
  onConfirm,
  labelBtnConfirmar,
  labelBtnCancelar,
  colorBtnCancelar,
  colorBtnConfirmar,
  align
}) {
  confirmAlert({
    closeOnClickOutside: false,
    customUI: ({ onClose }) => {
      return (
        <div className={styles.container}>
          <div className={styles.container_titles}>
            <h1>{title}</h1>
            <h2 style={{ textAlign: align || "center" }}>{subtitle}</h2>
          </div>
          <div className={styles.container_buttons}>
            {onConfirm && (
              <button
                onClick={() => {
                  onConfirm();
                  onClose();
                }}
                style={{
                  backgroundColor: colorBtnConfirmar || "#0b813c",
                }}
              >
                {labelBtnConfirmar || "Fechar"}
              </button>
            )}
            <button
              onClick={onClose}
              style={{
                backgroundColor: colorBtnCancelar || "#ef9f00",
              }}
            >
              {labelBtnCancelar || "Fechar"}
            </button>
          </div>
        </div>
      );
    },
  });
}
